export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/7166e5532cee15859202ed7458326e95.png";